export enum PlanFeature {
  AiContentGap,
  AiMetrics,
  RefreshContentLight,
  RefreshContentMajor,
  SupportingMaterials,
  EnabledArticles,
  EnabledProducts,
  EnabledCollections,
}

export enum PlanError {
  PlanMissing = 'ERROR_PLAN_MISSING',

  FeatureMisusage = 'ERROR_FEATURE_MISUSAGE',

  FeatureAiContentGapMissing = 'ERROR_FEATURE_AI_CONTENT_GAP_MISSING',
  FeatureAiMetricsMissing = 'ERROR_FEATURE_AI_METRICS_MISSING',
  FeatureRefreshContentLightMissing = 'ERROR_FEATURE_REFRESH_CONTENT_LIGHT_MISSING',
  FeatureRefreshContentMajorMissing = 'ERROR_FEATURE_REFRESH_CONTENT_MAJOR_MISSING',
  FeatureSupportingMaterialsMissing = 'ERROR_FEATURE_SUPPORTING_MATERIALS_MISSING',
  FeatureEnabledArticlesMissing = 'ERROR_FEATURE_ENABLED_ARTICLES_MISSING',
  FeatureEnabledProductsMissing = 'ERROR_FEATURE_ENABLED_PRODUCTS_MISSING',
  FeatureEnabledCollectionsMissing = 'ERROR_FEATURE_ENABLED_COLLECTIONS_MISSING',

  FeatureAiOverviewMissing = 'ERROR_FEATURE_AI_OVERVIEW_MISSING',

  FeatureMaxTeamUserCountInsufficient = 'ERROR_FEATURE_MAX_TEAM_USER_COUNT_INSUFFICIENT',
  FeatureMaxBrandCountInsufficient = 'ERROR_FEATURE_MAX_BRAND_COUNT_INSUFFICIENT',

  InsufficientCredits = 'ERROR_INSUFFICIENT_CREDITS',

  LimitArticleTrialing = 'ERROR_LIMIT_ARTICLE_TRIALING',
  LimitArticleFree = 'ERROR_LIMIT_ARTICLE_FREE',
  UnableToChangeArticle = 'ERROR_UNABLE_TO_CHANGE_ARTICLE',
}
